import base from '@/services/notifications/index';
export default Object.assign({}, base);
